var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-underscore-dangle */
import { EVENTS } from '../../eventsTracking';
import { trackEvent } from '@raisin/events-tracking';
import { getCMSIcons, getCMSEntriesForContentType, fetchDataErrorHandler, fetchTrustpilot, PLATFORM_STACK_NAME, pick, } from '@raisin/cp-utils';
export const normalizeSocialMediaIcons = (iconsSet, socialMedia) => socialMedia.map((item) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        uid: (_b = (_a = item === null || item === void 0 ? void 0 : item._metadata) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : '',
        iconUrl: (_d = iconsSet[(_c = item === null || item === void 0 ? void 0 : item.icon) === null || _c === void 0 ? void 0 : _c[0].uid]) !== null && _d !== void 0 ? _d : '',
        link: (_e = item === null || item === void 0 ? void 0 : item.link) !== null && _e !== void 0 ? _e : '',
        account: (_f = item === null || item === void 0 ? void 0 : item.social_media_account) !== null && _f !== void 0 ? _f : '',
    });
});
const getIconsUID = (entryWithIconReference) => {
    var _a;
    if ((Array.isArray(entryWithIconReference) && !entryWithIconReference.length) ||
        (!Array.isArray(entryWithIconReference) && !(entryWithIconReference === null || entryWithIconReference === void 0 ? void 0 : entryWithIconReference.icon.length))) {
        return [];
    }
    if (Array.isArray(entryWithIconReference)) {
        return entryWithIconReference === null || entryWithIconReference === void 0 ? void 0 : entryWithIconReference.reduce((acc, curVal) => {
            var _a;
            acc.push((_a = curVal === null || curVal === void 0 ? void 0 : curVal.icon) === null || _a === void 0 ? void 0 : _a[0].uid);
            return acc;
        }, []);
    }
    return [(_a = entryWithIconReference === null || entryWithIconReference === void 0 ? void 0 : entryWithIconReference.icon) === null || _a === void 0 ? void 0 : _a[0].uid];
};
export const fetchIconURL = (locale, entry) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // eslint-disable-next-line @typescript-eslint/return-await
        return yield getCMSIcons(PLATFORM_STACK_NAME, locale, entry);
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return {};
    }
});
export const getIconsURL = (locale, iconUIDs) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield Promise.all(iconUIDs.map((uid) => fetchIconURL(locale, uid)));
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return [];
    }
});
export const fetchFooterData = (locale, settings) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g;
    const footerUid = (_c = (_b = (_a = settings[0]) === null || _a === void 0 ? void 0 : _a.navigation) === null || _b === void 0 ? void 0 : _b.footer[0]) === null || _c === void 0 ? void 0 : _c.uid;
    const footer = yield getCMSEntriesForContentType(PLATFORM_STACK_NAME, locale, 'footer', footerUid).catch((e) => {
        fetchDataErrorHandler(e, 'footer data');
    });
    let footerData;
    // If footerData is an array, we will use the retail footer as default which has pos 0.
    if (Array.isArray(footer)) {
        [footerData] = footer;
    }
    else {
        footerData = footer;
    }
    const contactInformationReference = (_d = footerData.contact_information) === null || _d === void 0 ? void 0 : _d[0];
    let contactInformationData;
    let phoneIconUID = [];
    let emailIconUID = [];
    if (contactInformationReference) {
        contactInformationData = yield getCMSEntriesForContentType(PLATFORM_STACK_NAME, locale, contactInformationReference === null || contactInformationReference === void 0 ? void 0 : contactInformationReference._content_type_uid, contactInformationReference === null || contactInformationReference === void 0 ? void 0 : contactInformationReference.uid).catch(() => {
            // eslint-disable-next-line no-console
            console.error('There was an error fetching the contact information data from ContentStack');
            return {};
        });
        if (contactInformationData && Object.keys(contactInformationData).length !== 0) {
            phoneIconUID = getIconsUID(contactInformationData.phone);
            emailIconUID = getIconsUID(contactInformationData.email);
        }
    }
    const usContactBannerReference = (_e = footerData.us_contact_banner) === null || _e === void 0 ? void 0 : _e[0];
    let usContactBanner = null;
    if (usContactBannerReference) {
        const usContactBannerData = yield getCMSEntriesForContentType(PLATFORM_STACK_NAME, locale, usContactBannerReference === null || usContactBannerReference === void 0 ? void 0 : usContactBannerReference._content_type_uid, usContactBannerReference === null || usContactBannerReference === void 0 ? void 0 : usContactBannerReference.uid).catch(() => {
            // eslint-disable-next-line no-console
            console.error('There was an error fetching the contact information data from ContentStack');
            return {};
        });
        if (usContactBannerData && Object.keys(usContactBannerData).length) {
            usContactBanner = usContactBannerData;
        }
    }
    const socialMediaIconsUID = getIconsUID(footerData.social_media);
    const mobileBannerIconUID = getIconsUID(footerData.mobile_banner);
    const footerIconsUID = [
        ...socialMediaIconsUID,
        ...phoneIconUID,
        ...emailIconUID,
        ...mobileBannerIconUID,
    ];
    const icons = yield getIconsURL(locale, footerIconsUID);
    const mutatedIcons = icons.reduce((obj, item) => (Object.assign(Object.assign({}, obj), { [Object.keys(item)[0]]: Object.values(item)[0] })), {});
    const trustpilotData = yield fetchTrustpilot(locale);
    return Object.assign(Object.assign({}, pick('trustpilotData', 'socialMediaIcons', 'contactInformationData', 'contactInformationData', 'mobileBannerIconURL', 'display_trustpilot', 'displayUsContactBanner', 'hideFooterLinks', 'footer_links', 'legal_links', 'copyright', 'credits', 'disclaimer', 'mobile_banner', 'hideSocialMediaHeading', 'usContactBanner', 'hideFooter', 'hideCountryPicker')(footerData)), { usContactBanner: usContactBanner !== null && usContactBanner !== void 0 ? usContactBanner : null, displayUsContactBanner: (_f = footerData.display_us_contact_banner) !== null && _f !== void 0 ? _f : false, hideSocialMediaHeading: (_g = footerData.hide_social_media_heading) !== null && _g !== void 0 ? _g : false, contactInformationData: contactInformationData !== null && contactInformationData !== void 0 ? contactInformationData : null, phoneIconURL: phoneIconUID.length ? mutatedIcons[phoneIconUID[0]] : null, emailIconURL: emailIconUID.length ? mutatedIcons[emailIconUID[0]] : null, mobileBannerIconURL: mobileBannerIconUID.length ? mutatedIcons[mobileBannerIconUID[0]] : null, socialMediaIcons: normalizeSocialMediaIcons(mutatedIcons, footerData.social_media).length
            ? normalizeSocialMediaIcons(mutatedIcons, footerData.social_media)
            : null, trustpilotData: trustpilotData !== null && trustpilotData !== void 0 ? trustpilotData : null });
});
export const trackFooterNavigation = (linkUrl) => {
    const eventName = `${linkUrl}-tapped`;
    trackEvent(Object.assign(Object.assign({}, EVENTS.FOOTER_LEGAL_MENU_LINK_TAPPED), { eventName, object: linkUrl, description: `${eventName} on the footer-navigation inside customer-portal` }));
};
//# sourceMappingURL=footer.js.map